module.exports = __webpack_public_path__ + "img/mark_palm_upper_image.52ee659e.svg";